class ModernNav extends HTMLElement {
  connectedCallback() {
    this.menuGroups = this.querySelectorAll('.header-menu-tabs');

    this.menuGroups.forEach((menuGroup) => {
      const tabs = menuGroup.querySelectorAll('[data-modern-nav-tab]');
      const container = menuGroup.querySelector('.header-menu-tabs__container');

      tabs.forEach((tab) => {
        tab.addEventListener('pointerenter', () => this.setActiveTab(menuGroup, tab.dataset.modernNavTab));
        tab.addEventListener('focusin', () => this.setActiveTab(menuGroup, tab.dataset.modernNavTab));
      });

      // Reset once the dropdown has faded out, so the panel does not swap back
      // to the first tab while the close transition is still running.
      container?.addEventListener('transitionend', (event) => {
        if (event.target !== container || event.propertyName !== 'opacity') return;
        if (getComputedStyle(container).visibility === 'hidden') this.resetActiveTab(menuGroup);
      });

      menuGroup.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!menuGroup.contains(document.activeElement)) this.resetActiveTab(menuGroup);
        });
      });

      this.resetActiveTab(menuGroup);
    });
  }

  setActiveTab(menuGroup, tabId) {
    const activeTab = menuGroup.querySelector(`[data-modern-nav-tab="${tabId}"]`);
    const activePanel = menuGroup.querySelector(`[data-modern-nav-panel="${tabId}"]`);

    this.clearActiveTab(menuGroup);
    if (!activePanel) return;

    activeTab.classList.add('is-active');
    activePanel.classList.add('is-active');
  }

  resetActiveTab(menuGroup) {
    const firstTab = menuGroup.querySelector('[data-modern-nav-tab]');

    if (!firstTab) {
      this.clearActiveTab(menuGroup);
      return;
    }

    this.setActiveTab(menuGroup, firstTab.dataset.modernNavTab);
  }

  clearActiveTab(menuGroup) {
    menuGroup.querySelectorAll('.is-active').forEach((element) => element.classList.remove('is-active'));
  }
}

if (!customElements.get('modern-nav')) customElements.define('modern-nav', ModernNav);
